import { kea } from "kea";

import api from '../utils/api';

export const feedbacklogic = kea({
	actions: {
		submit: (feedback) => ({ feedback }),

		setError: (error) => ({ error }),
		setSuccess: (success) => ({ success }),
	},
	reducers: {
		loading: [false, {
			submit: () => true,

			setError: () => false,
			setSuccess: () => false,
		}],
		error: [null, {
			setSuccess: () => null,
			setError: (_, { error }) => [error],
		}],
		success: [null, {
			setError: () => null,
			setSuccess: (_, { success }) => [success]
		}]
	},
	listeners: ({ actions }) => ({
		submit: async ({ feedback }, breakpoint) => {
			let url = '/feedback';
			let res;
			try {
				res = await api({ url, method: 'post', body: feedback });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			breakpoint();
			const json = await res.json();
			if (res.ok) actions.setSuccess('Feedback Submitted. Thank you!');
			else actions.setError(json.error);
		}
	})
});

export default feedbacklogic;